import { ResolveGroupHeaderTopSpacingParams } from './orderProductGroupHeader.types';

const GROUP_TOP_SPACING = 0.5;
const SUB_GROUP_TOP_SPACING = 1;
const BELOW_DESKTOP_TOP_SPACING = 1.5;

export const resolveGroupHeaderTopSpacing = ({
  hasTopSpacing,
  isSubGroup,
  isBelowDesktop,
}: ResolveGroupHeaderTopSpacingParams) => {
  if (!hasTopSpacing) {
    return 0;
  }

  if (isBelowDesktop) {
    return BELOW_DESKTOP_TOP_SPACING;
  }

  return isSubGroup ? SUB_GROUP_TOP_SPACING : GROUP_TOP_SPACING;
};
